import { createContext, useState } from "react";

const ConciliacaoBancariaContext = createContext();

const ConciliacaoBancariaContextProvider = ({ children }) => {
  const [fileId, setFileId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bankAccountsList, setBankAccountsList] = useState([]);
  const [bankAccount, setBankAccount] = useState(null);
  const [searchMovimentations, setSearchMovimentations] = useState([]);
  const [itensTotalMovimentations, setItensTotalMovimentations] = useState(0);
  const [searchPayments, setSearchPayments] = useState([]);
  const [itensTotalPayments, setItensTotalPayments] = useState(0);
  const [searchReceipts, setSearchReceipts] = useState([]);
  const [itensTotalReceipts, setItensTotalReceipts] = useState(0);
  const [errors, setErrors] = useState({});
  const [mainClient, setMainClient] = useState(null);
  const [mainSupplier, setMainSupplier] = useState(null);
  const [alertCategory, setAlertCategory] = useState("");
  const [historicVisualization, setHistoricVisualization] = useState(false);
  const [mismatchValue, setMismatchValue] = useState(0);
  const [needMismatchValueFullfill, setNeedMismatchValueFullfill] =
    useState(false);
  const [conciliationType, setConciliationType] = useState(null);
  const [openFinanceConciliationLoading, setOpenFinanceConciliationLoading] =
    useState(false);

  return (
    <ConciliacaoBancariaContext.Provider
      value={{
        fileId,
        setFileId,
        loading,
        setLoading,
        bankAccountsList,
        setBankAccountsList,
        bankAccount,
        setBankAccount,
        searchMovimentations,
        setSearchMovimentations,
        itensTotalMovimentations,
        setItensTotalMovimentations,
        searchPayments,
        setSearchPayments,
        itensTotalPayments,
        setItensTotalPayments,
        searchReceipts,
        setSearchReceipts,
        itensTotalReceipts,
        setItensTotalReceipts,
        errors,
        setErrors,
        mainClient,
        setMainClient,
        mainSupplier,
        setMainSupplier,
        alertCategory,
        setAlertCategory,
        historicVisualization,
        setHistoricVisualization,
        mismatchValue,
        setMismatchValue,
        needMismatchValueFullfill,
        setNeedMismatchValueFullfill,
        conciliationType,
        setConciliationType,
        openFinanceConciliationLoading,
        setOpenFinanceConciliationLoading,
      }}
    >
      {children}
    </ConciliacaoBancariaContext.Provider>
  );
};

export { ConciliacaoBancariaContextProvider, ConciliacaoBancariaContext };
